import { useRef, useState } from "react";
import { useRadioPlayer } from "../../hooks/useRadioPlayer";
import { RadioPlayerContext } from "../../providers/RadioPlayerContext";
import BackgroundOverlay from "./backgroundOverlay";
import ChannelList from "./channelList";
import Footer from "./footer";
import Header from "./header";
import MainContent from "./mainContent";

const MusicPlayer = () => {
  const audioMainRef = useRef(null);
  const audioNextRef = useRef(null);

  const radioPlayer = useRadioPlayer(audioMainRef, audioNextRef);
  const { currentChannel } = radioPlayer;

  const [isOpen, setIsOpen] = useState(false);

  return (
    <RadioPlayerContext.Provider value={radioPlayer}>
      <div
        className="h-full flex flex-col justify-between xxxs:pt-3 pb-10 px-4 bg-cover bg-center bg-no-repeat relative"
        style={{
          backgroundImage: `url(${currentChannel?.channelCover})`,
        }}
      >
        <BackgroundOverlay />
        <Header />
        <MainContent />
        <Footer setIsOpen={setIsOpen} />
        <ChannelList isOpen={isOpen} setIsOpen={setIsOpen} />

        <audio ref={audioMainRef} hidden />
        <audio ref={audioNextRef} hidden preload="auto" />
      </div>
    </RadioPlayerContext.Provider>
  );
};

export default MusicPlayer;
